import webBiLogger from '@wix/web-bi-logger';
import { getSessionId } from '../../../../utils/env/getSessionId';
import { removeUndefinedValues } from '../../../../utils/object';
import { IErrorParams, Severity } from '../ErrorLogger.types';
import { reasonToString } from '../utils';

const biErrorLogger = webBiLogger
  .factory({ endpoint: 'trg' })
  .updateDefaults({
    src: 26,
    evid: 10,
    sessionId: getSessionId(),
  })
  .logger();

let extraParams;
export function updateBiGlobalInfo({ metaSiteId }) {
  extraParams = { metaSiteId };
}

const limit = (maybeString) => {
  const string = String(maybeString);
  return string && string.slice(0, 900);
};

export function biErrorLoggerConsumer({ errorDefinition, reason, p1, p2, p3, p4 }: IErrorParams) {
  biErrorLogger.log(
    removeUndefinedValues({
      ...extraParams,
      errc: errorDefinition.id,
      errn: errorDefinition.name,
      sev: errorDefinition.severity || Severity.ERROR,
      dsc: limit(reasonToString(reason)),
      p1: limit(p1),
      p2: limit(p2),
      p3: limit(p3),
      p4: limit(p4),
    }),
  );
}
